export const ProgramWeekWorkouts = {
  bindings: {
    completions: '<',
    member: '<',
    onCardClick: '&',
    onCompleterToggle: '&',
    voomeProductId: '<',
    weekNumber: '<',
    items: '<',
  },

  template: `
    <div class="container program-week-workouts">
      <section class="section-carousel">
        <h4>
          <span class="aside">
            Week {{ $ctrl.weekNumber }}
          </span>
          Workouts
        </h4>
        <carousel
          list="$ctrl.items"
          settings="{ slidesToShow: 3 }">
          <div class="carousel-slide-wrapper"
            ng-repeat="item in $ctrl.items track by item.dayString + item.id">
            <div class="carousel-slide">
              <completer
                title="{{ 'Session ' + ($index + 1) }}"
                is-complete="$ctrl.completions[item.id]"
                on-toggle="$ctrl.onCompleterToggle({
                  exercisePlanId: item.exercisePlanId,
                  dayId: item.id,
                  voomeProductId: $ctrl.voomeProductId,
                  weekNumber: $ctrl.weekNumber,
                  title: 'Session ' + ($index + 1),
                  isComplete: $ctrl.completions[item.id]
                })">
              </completer>
              <card-workout
                workout="item"
                member="$ctrl.member"
                on-click="$ctrl.onCardClick({ id: item.id, exercisePlanId: item.exercisePlanId })">
              </card-workout>
            </div>
          </div>
        </carousel>
      </section>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Program/ProgramWeekWorkouts.js